import {
  SIZE,
  NOTIFICATION_TYPE,
  ASSISTANT_TYPE,
  DEFECATION_TYPE_JA,
  DEFECATION_TYPE_EN,
  DRINKING_TYPE,
  HARDNESS_TYPE_JA,
  HARDNESS_TYPE_EN,
  INCONTINENCE_TYPE_JA,
  INCONTINENCE_TYPE_EN,
  PAD_TYPE_JA,
  PAD_TYPE_EN,
  TOILET_TYPE_JA,
  TOILET_TYPE_EN,
  URINE_TYPE_JA,
  URINE_TYPE_EN,
  LAXATIVE_UNIT_JA,
  IS_LEAK_OUT_FECES_EN,
  IS_LEAK_OUT_FECES_JA,
  IS_LEAK_OUT_URINE_JA,
  IS_LEAK_OUT_URINE_EN,
  IS_URGENCY_JA,
  IS_URGENCY_EN,
  URINATED_TOILET_JA,
  URINATED_TOILET_EN,
  BOOLEAN_TYPE_JA,
  BOOLEAN_TYPE_EN,
  ACTIVITY_STATUS_POS_CODES_JA,
  ACTIVITY_STATUS_POS_CODES_EN,
  ACTIVITY_STATUS_POS_NUM,
} from '../constants';

export const formatBooleanJa = (data: boolean) => {
  return BOOLEAN_TYPE_JA[data.toString()] ? BOOLEAN_TYPE_JA[data.toString()] : data;
};

export const formatBooleanEn = (data: boolean) => {
  return BOOLEAN_TYPE_EN[data.toString()] ? BOOLEAN_TYPE_EN[data.toString()] : data;
};

export const formatSize = (data: string) => {
  return SIZE[data] ? SIZE[data] : data;
};

export const formatNotification = (data: string) => {
  return NOTIFICATION_TYPE[data] ? NOTIFICATION_TYPE[data] : data;
};

export const formatToiletJa = (data: string) => {
  return TOILET_TYPE_JA[data] ? TOILET_TYPE_JA[data] : data;
};

export const formatToiletEn = (data: string) => {
  return TOILET_TYPE_EN[data] ? TOILET_TYPE_EN[data] : data;
};

export const formatPadJa = (data: string) => {
  return PAD_TYPE_JA[data] ? PAD_TYPE_JA[data] : data;
};

export const formatPadEn = (data: string) => {
  return PAD_TYPE_EN[data] ? PAD_TYPE_EN[data] : data;
};

export const formatUrinedToiletJa = (data: boolean) => {
  return URINATED_TOILET_JA[data.toString()] ? URINATED_TOILET_JA[data.toString()] : data;
};

export const formatUrinedToiletEn = (data: boolean) => {
  return URINATED_TOILET_EN[data.toString()] ? URINATED_TOILET_EN[data.toString()] : data;
};

export const formatUrineJa = (data: string) => {
  return URINE_TYPE_JA[data] ? URINE_TYPE_JA[data] : data;
};

export const formatUrineEn = (data: string) => {
  return URINE_TYPE_EN[data] ? URINE_TYPE_EN[data] : data;
};

export const formatIsUrgencyJa = (data: boolean) => {
  return IS_URGENCY_JA[data.toString()] ? IS_URGENCY_JA[data.toString()] : data;
};
export const formatIsUrgencyEn = (data: boolean) => {
  return IS_URGENCY_EN[data.toString()] ? IS_URGENCY_EN[data.toString()] : data;
};

export const formatIsLeakOutUrineJa = (data: boolean) => {
  return IS_LEAK_OUT_URINE_JA[data.toString()] ? IS_LEAK_OUT_URINE_JA[data.toString()] : data;
};
export const formatIsLeakOutUrineEn = (data: boolean) => {
  return IS_LEAK_OUT_URINE_EN[data.toString()] ? IS_LEAK_OUT_URINE_EN[data.toString()] : data;
};

export const formatDefecationJa = (data: string) => {
  return DEFECATION_TYPE_JA[data] ? DEFECATION_TYPE_JA[data] : data;
};

export const formatDefecationEn = (data: string) => {
  return DEFECATION_TYPE_EN[data] ? DEFECATION_TYPE_EN[data] : data;
};

export const formatHardnessJa = (data: string) => {
  return HARDNESS_TYPE_JA[data] ? HARDNESS_TYPE_JA[data] : data;
};
export const formatHardnessEn = (data: string) => {
  return HARDNESS_TYPE_EN[data] ? HARDNESS_TYPE_EN[data] : data;
};
export const formatIsLeakOutFecesJa = (data: boolean) => {
  return IS_LEAK_OUT_FECES_JA[data.toString()] ? IS_LEAK_OUT_FECES_JA[data.toString()] : data;
};
export const formatIsLeakOutFecesEn = (data: boolean) => {
  return IS_LEAK_OUT_FECES_EN[data.toString()] ? IS_LEAK_OUT_FECES_EN[data.toString()] : data;
};

export const formatIncontinenceJa = (data: string) => {
  return INCONTINENCE_TYPE_JA[data] ? INCONTINENCE_TYPE_JA[data] : data;
};

export const formatIncontinenceEn = (data: string) => {
  return INCONTINENCE_TYPE_EN[data] ? INCONTINENCE_TYPE_EN[data] : data;
};

export const formatAssistant = (data: string) => {
  return ASSISTANT_TYPE[data] ? ASSISTANT_TYPE[data] : data;
};

export const formatDrinkingType = (data: string) => {
  return DRINKING_TYPE[data] ? DRINKING_TYPE[data] : data;
};

export const formatLaxativeUnitJa = (data: string) => {
  return LAXATIVE_UNIT_JA[data] || data;
};

export const formatPostureJa = (data: number) => {
  return Object.prototype.hasOwnProperty.call(ACTIVITY_STATUS_POS_CODES_JA, data)
    ? ACTIVITY_STATUS_POS_CODES_JA[data as ACTIVITY_STATUS_POS_NUM]
    : data;
};

export const formatPostureEn = (data: number) => {
  return Object.prototype.hasOwnProperty.call(ACTIVITY_STATUS_POS_CODES_EN, data)
    ? ACTIVITY_STATUS_POS_CODES_EN[data as ACTIVITY_STATUS_POS_NUM]
    : data;
};  
